import { useQuery } from '@tanstack/react-query';
import { isAddress } from 'viem';
import { normalize } from 'viem/ens';
import { useConnectedAuth } from '@context/auth/connected';
import { AVAILABLE_CHAIN_IDS } from '@utils/constants';

export function useValidateWalletOrEns({ input }: { input: string | null }) {
  const client = useConnectedAuth().provider(AVAILABLE_CHAIN_IDS.eth);

  const validate = useQuery({
    queryKey: ['validateWalletOrEnsInput', input],
    queryFn: async () => {
      if (!input || input === '') {
        return {
          type: 'empty-input',
        } as const;
      }
      const lowerCaseInput = input.toLowerCase();

      if (lowerCaseInput.startsWith('0x') && isAddress(lowerCaseInput)) {
        return {
          type: 'address',
          value: lowerCaseInput,
        } as const;
      } else if (lowerCaseInput.endsWith('.eth')) {
        try {
          const ensAddress = await client.getEnsAddress({
            name: normalize(lowerCaseInput),
          });

          if (!!ensAddress) {
            return {
              type: 'address',
              value: ensAddress,
            } as const;
          } else {
            return {
              type: 'invalid-ens',
            } as const;
          }
        } catch {
          return {
            type: 'invalid-ens',
          } as const;
        }
      } else {
        return {
          type: 'invalid-address',
        } as const;
      }
    },
    keepPreviousData: true,
  });

  return validate;
}
